import React from 'react';
import { DashboardOutstandingByMonthPivotToggleButton } from './components/DashboardOutstandingByMonthPivotToggleButton';
import { DashboardOutstandingByMonthPivotMode } from '../../../../../constants/DashboardOutstandingByMonthPivotMode';

export const Toolbar: React.FC<{
    pivotMode: DashboardOutstandingByMonthPivotMode;
    set_pivotMode: (mode: DashboardOutstandingByMonthPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    return (
        <div className='mode-bar'>
            <div className='mode-item'>Outstanding</div>
            <div className='mode-item'>
                Period Closed In And Still Outstanding
                <span className='toggle-wrapper'>
                    <DashboardOutstandingByMonthPivotToggleButton
                        pivotMode={pivotMode}
                        set_pivotMode={set_pivotMode}
                    />
                </span>
            </div>
        </div>
    );
};
